import { Box, Button, Link, Typography } from '@mui/material';
import { useRouter } from '@tanstack/react-router';
import type { FC, JSX } from 'react';
import { SUPPORT_EMAIL } from 'utils';

import type { TRouteErrorProps } from '../types';

export const RouteErrorBoundary: FC<TRouteErrorProps> = ({ reset }): JSX.Element => {
  const router = useRouter();

  const handleRetry = (): void => {
    reset();
  };

  const handleGoHome = (): void => {
    void router.navigate({ to: '/' });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      gap={4}
      p={4}
      textAlign="center"
    >
      <Typography variant="h1">Something went wrong</Typography>
      <Typography variant="body1" color="custom.textGrey">
        We encountered an unexpected error. Please try again.
      </Typography>
      <Box display="flex" gap={2}>
        <Button variant="contained" onClick={handleRetry}>
          Try Again
        </Button>
        <Button variant="outlined" onClick={handleGoHome}>
          Go Home
        </Button>
      </Box>
      <Typography variant="body2" color="custom.textGrey">
        If the problem persists, contact us at <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
      </Typography>
    </Box>
  );
};
